export function defferedOnContentLoaded() {
    if (document.readyState != 'complete') {
        return;
    }

    document.removeEventListener("DOMContentLoaded", showCookieBanner, false);

    showCookieBanner(false);
}

export function defferShowCookieBanner() {
    document.addEventListener("DOMContentLoaded", defferedOnContentLoaded, false);
}

export function showCookieBanner(allowDeffer = true) {
    const cookiebanner = document.getElementById("cookiebanner");

    const template = document.getElementById("cookiebot-banner-tpl");
    if (typeof template == 'undefined' || typeof cookiebanner == 'undefined') {
        if (allowDeffer) {
            defferShowCookieBanner();
        }

        return;
    }

    const cookiebannerConfig = document.querySelector('meta[name="cookiebot-banner"]');
    const showCookiebanner = cookiebannerConfig?.content != 'off';

    cookiebanner.replaceWith(template.content.cloneNode(true));

    cookiebanner.style.bottom = 0;

    if (!showCookiebanner) {
        hideCookieBanner();
    }

    if (typeof cookiebannerConfig != 'undefined') {
        cookiebannerConfig.content = 'on';
    }
}

export function hideCookieBanner() {
    const cookiebanner = document.getElementById("cookiebanner");

    cookiebanner.remove();
}

window.showCookieBanner = showCookieBanner;
window.hideCookieBanner = hideCookieBanner;